import {
  investeeStates,
  investorStates,
  intermediaryStates,
  matchStates,
  seekersStates,
} from "@/platforms/zidr/states";

const orderPerRole = {
  investee: [
    "wip",
    "applied",
    "inPipeline",
    "published",
    "funded",
    "inelligible",
    "rejected",
    "archived",
  ],
  investor: ["new", "review", "investment", "unqualified", "archived"],
  seeker: ["new", "review", "active", "unqualified", "archived"],
  match: ["interest", "talks", "exclusive", "partial", "closed", "abandon"],
};

const stateMaps = {
  investee: investeeStates,
  investor: investorStates,
  intermediary: intermediaryStates,
  seeker: seekersStates,
  match: matchStates,
};

const getChartData = (data, entity = "investee") => {
  const order = orderPerRole[entity] || [];
  const map = stateMaps[entity];
  if (!map) {
    return [];
  }

  const dataByStatus = {};
  for (let item in data) {
    const index = data[item]?._id?.state || data[item]._id;
    const status = map[index];
    if (!status) {
      continue;
    }
    dataByStatus[status.value] = {
      name: status.label || status.value,
      chartColor: status.chartColor,
      count: data[item].count,
    };
  }

  const dataSet = order.map((item) => {
    const statusData = dataByStatus[item] || map[item] || {};
    return {
      x: statusData?.name || statusData?.label || statusData?.value || item,
      y: statusData?.count || 0,
      fillColor: statusData?.chartColor || "",
    };
  });

  return dataSet;
};

const getStatusCounts = (state, entity = "investee") => {
  const response = {};
  const map = stateMaps[entity];
  if (!map) {
    return response;
  }

  for (let item in map) {
    const name = map[item].value;
    response[name] = { count: 0 };
  }

  const data = state.statusCount?.[entity];

  for (let item in data) {
    const index = data[item]?._id?.state || data[item]._id;
    const status = map[index];
    if (!status) {
      continue;
    }
    response[status.value].count = data[item].count;
  }

  return response;
};

const bottomLinks = {
  investee: [
    {
      label: "Actions needed",
      links: [
        {
          link: "/investees?count=10&offset=0&state=applied",
          status: "applied",
          text: "Review Proposals",
          bg: "bg-info",
          entity: "investee",
          disabled: false,
        },
        {
          link: "/investees?count=10&offset=0&state=inPipeline",
          status: "inPipeline",
          text: "Prepare for publish",
          bg: "bg-success",
          entity: "investee",
          disabled: false,
        },
      ],
    },
    {
      label: "Exited Workflow",
      links: [
        {
          link: "/investees?count=10&offset=0&state=inelligible",
          status: "inelligible",
          text: "Failed Eligibility Check",
          bg: "bg-danger",
          entity: "investee",
          disabled: false,
        },
        {
          link: "/investees?count=10&offset=0&state=rejected",
          status: "rejected",
          text: "Rejected",
          bg: "bg-danger",
          entity: "investee",
          disabled: false,
        },
        // {
        //   link: "/investees?count=10&offset=0&state=closed",
        //   status: "closed",
        //   text: "Success",
        //   bg: "bg-success",
        //   entity: "investee",
        //   disabled: false,
        // },
        {
          link: "/investees?count=10&offset=0&state=archived",
          status: "archived",
          text: "Archived",
          bg: "bg-danger",
          entity: "investee",
          disabled: false,
        },
      ],
    },
  ],
  seeker: [
    {
      label: "Exited Workflow",
      links: [
        {
          link: "/seekers?count=10&offset=0&state=unqualified",
          status: "unqualified",
          text: "Unqualified",
          bg: "bg-danger",
          entity: "seeker",
          disabled: false,
        },
        {
          link: "/seekers?count=10&offset=0&state=archived",
          status: "archived",
          text: "Archived",
          bg: "bg-danger",
          entity: "seeker",
          disabled: false,
        },
      ],
    },
  ],
};

export { getChartData, getStatusCounts, bottomLinks };
